import {
  TableCell,
  TableFooterCell,
  TableRow,
  TableColumnHeader,
  Table
} from '@/common'
import useI18n from '@/shared/hooks/useI18n'

export default function ReportDirectEmissionsTable({
  superDense = false,
  formattedTotalDirect,
  formattedTotalIndirect,
  formattedSpecificDirect,
  formattedSpecificIndirect
}: {
  superDense?: boolean
  formattedTotalDirect: string
  formattedTotalIndirect: string
  formattedSpecificDirect: string
  formattedSpecificIndirect: string
}) {
  const { t } = useI18n()

  return (
    <Table className="h-full" superDense={superDense}>
      <thead>
        <TableRow>
          <TableColumnHeader align="right" colSpan={2}>
            {t('report:emissionReportStatusControl.direct')}
          </TableColumnHeader>
          <TableColumnHeader align="right">
            {t('report:emissionReportStatusControl.indirect')}
          </TableColumnHeader>
        </TableRow>
      </thead>
      <tbody>
        <TableRow>
          <TableCell align="right">
            {t('report:emissionReportStatusControl.specificEmbeddedEmissions')}
          </TableCell>
          <TableCell align="right">{formattedSpecificDirect}</TableCell>
          <TableCell align="right">{formattedSpecificIndirect}</TableCell>
        </TableRow>
      </tbody>
      <tfoot>
        <TableRow>
          <TableFooterCell align="right">
            {t('report:emissionReportStatusControl.totalEmbeddedEmissions')}
          </TableFooterCell>
          <TableFooterCell align="right">{formattedTotalDirect}</TableFooterCell>
          <TableFooterCell align="right">{formattedTotalIndirect}</TableFooterCell>
        </TableRow>
      </tfoot>
    </Table>
  )
}
